export const TIPO_FORMA_PAGTO_CARTAO = 2;
export const TIPO_FORMA_PAGTO_DINHEIRO = 5;

/**
 * Port 1:1 de `PassoDoisConstants.jsx` real — dado puro, sem dependência de
 * React/Redux/MUI, mapeando cada item da lista "Análise do Acordo" ao par de
 * campos (cor/mensagem) correspondente em `dadosResumo.jsonErros`.
 */
export const ITEMS_ANALISE_ACORDO = [
  { name: 'Data do Primeiro Vencimento', colorProp: 'corDataPrimeiroVencimento', messageProp: 'mensagemDataPrimeiroVencimento' },
  { name: 'Intervalo entre os Pagamentos', colorProp: 'corIntervaloPagamentos', messageProp: 'mensagemIntervaloPagamentos' },
  { name: 'Quantidade de Parcelas', colorProp: 'corQuantidadeParcelas', messageProp: 'mensagemQuantidadeParcelas' },
  { name: 'Taxa de Juros', colorProp: 'corTaxaJuros', messageProp: 'mensagemTaxaJuros' },
  { name: 'Honorários', colorProp: 'corTaxaHonorarios', messageProp: 'mensagemTaxaHonorarios' },
  { name: 'Descontos', colorProp: 'corTaxaDescontos', messageProp: 'mensagemTaxaDescontos' },
];
